import React from 'react'
import { useIntl } from 'react-intl'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import styled from 'styled-components'
import showDetailsIcon from '../../../assets/icons/showDetailsIcon.svg'
import { CreateDropoffContactErrors } from '../../../core/application/formValidation/createDropoffFormValidator'
import { openingHoursToString } from '../../../core/application/utils/openingHoursUtils'
import { NewDropoffContact } from '../../../core/domain/models/NewDropoff'
import InputContainer, { InputContainerBackground } from '../inputs/InputContainer'
import TextInput from '../inputs/TextInput'

export interface ISubmitDropoffContactProps {
  contact?: NewDropoffContact
  updateContact: (contact: NewDropoffContact) => void
  errors?: CreateDropoffContactErrors
  shouldDisplayErrors: boolean
  displayOpeningTimeSelection: () => void
}

const SubmitDropoffContact: React.FC<ISubmitDropoffContactProps> = ({
  contact,
  updateContact,
  errors,
  shouldDisplayErrors,
  displayOpeningTimeSelection
}) => {
  const intl = useIntl()

  // Opening hours text
  let openingHoursText = intl.formatMessage({ id: 'SubmitDropoff.contact.opening.hours.placeholder' })
  if (contact?.openingHours) {
    openingHoursText = openingHoursToString(contact.openingHours, intl)
  }

  return (
    <SubmitDropoffContactContainer>
      <InputContainer background={InputContainerBackground.gray}>
        <OpeningHoursButtonContainer>
          <TextButton onClick={displayOpeningTimeSelection}>{openingHoursText}</TextButton>
          <DropdownIcon src={showDetailsIcon} alt="show-details" />
        </OpeningHoursButtonContainer>
      </InputContainer>
      <Phone
        value={contact?.phone}
        onChange={(value: any) =>
          updateContact({
            ...contact,
            phone: value
          } as NewDropoffContact)
        }
      />
      <InputContainer
        errorIntlKey={shouldDisplayErrors && errors?.website ? errors.website : undefined}
        background={InputContainerBackground.transparent}
      >
        <TextInput
          placeholder={intl.formatMessage({ id: 'SubmitDropoff.contact.website.placeholder' })}
          onChange={(value) =>
            updateContact({
              ...contact,
              website: value
            } as NewDropoffContact)
          }
          value={contact?.website || ''}
          id="website"
        />
      </InputContainer>
    </SubmitDropoffContactContainer>
  )
}
// react-tel-input
const Phone = styled(PhoneInput)`
  width: 100%;
  margin-top: 8px;

  & input {
    padding-top: 22px;
    padding-bottom: 22px;
    height: auto;
    width: 100% !important;
  }
`

const SubmitDropoffContactContainer = styled.div`
  width: 100%;
`

const TextButton = styled.button`
  flex-grow: 1;
  font-style: normal;
  font-weight: ${({ theme }) => theme.weight.normal};
  font-size: ${({ theme }) => theme.size.small};
  color: ${({ theme }) => theme.color.black};
  line-height: 18px;
  background: transparent;
  text-align: left;
  z-index: 2;
  cursor: pointer;
`

const OpeningHoursButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  cursor: pointer;
`

const DropdownIcon = styled.img`
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
`

export default SubmitDropoffContact
